import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import LookupsHelper from 'lib/LookupsHelper';
import Portlet from '../layout/Portlet';
import bronzeMembership from 'static/img/Bronze.png';
import silverMembership from 'static/img/Silver.png';
import goldMembership from 'static/img/Gold.png';
import platinumMembership from 'static/img/Platinum.png';
import trialMembership from 'static/img/Trial.png';
import vdfm from '../../static/img/favicon.jpg';

import VDFMDocument from '../dashboard/GDPR/VDFMDocument';
import HydraDocument from '../dashboard/GDPR/HydraDocument';

import { Descriptions, Row, Col, List, Avatar, Button, Modal } from 'antd';

import {
  PhoneOutlined,
  MobileOutlined,
  PrinterOutlined,
  MailOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';

const cyprusData = [
  {
    title: 'VDFM',
    icon: vdfm,
    doc: 'VDFM',
  },
  {
    title: 'Hydra Insurance',
    icon: 'https://www.hydrainsurance.com/images/logos-2_diafano_background.png',
    doc: 'HYDRA',
  },
];

const greekData = [
  {
    title: 'VDFM',
    icon: vdfm,
    doc: 'VDFM',
  },
];

const membershipObjects = [
  { Title: 'Bronze', Image: bronzeMembership, Message: 'Bronze' },
  { Title: 'Silver', Image: silverMembership, Message: 'Silver' },
  { Title: 'Gold', Image: goldMembership, Message: 'Golden' },
  { Title: 'Platinum', Image: platinumMembership, Message: 'Platinum' },
  { Title: 'Trial', Image: trialMembership, Message: 'Trial' },
];

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

const iconStyle = {
  marginLeft: 8,
  marginTop: 3,
};

const spanIconStyle = {
  display: 'flex',
  alignContent: 'center',
  // justifyContent: 'center',
};

const imageStyle = {
  marginRight: 10,
  height: '32px',
  width: '32px',
  textAlign: 'center',
};

const Profile = ({
  user,
  userParty,
  state,
  countries,
  partyTypes,
  regions,
  taxOffices,
  insurances,
  memberships,
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const [document, setDocument] = React.useState('');

  const membershipObject = React.useMemo(
    () =>
      user &&
      membershipObjects.find(
        x =>
          x.Title ===
          LookupsHelper.getDescription(memberships, user.MembershipId)
      ),
    [user, memberships]
  );

  const getCountryData = () => {
    if (userParty && userParty.CountryID === 51) return cyprusData;
    else return greekData;
  };

  const showDocument = doc => {
    setDocument(doc);

    setShowModal(true);
  };

  return (
    <div>
      <Portlet
        title={`${I.t('PROFILE_C')} - ${LookupsHelper.getDescription(
          partyTypes,
          user.PartyType
        )}`}
        icon="fa fa-user"
        bodyClassName="form"
        className="col-md-12"
      >
        <Row gutter={[16, 16]}>
          <Col xs={18}>
            <Row gutter={[10, 10]}>
              <Col className="profile">
                <Descriptions
                  colon={false}
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label="Username">
                    <span style={descriptionDetailsStyle}>
                      {user && user.Username}
                    </span>
                  </Descriptions.Item>
                  {membershipObject ? (
                    <Descriptions.Item label="Membership">
                      <img
                        style={imageStyle}
                        src={membershipObject && membershipObject.Image}
                        alt=""
                      />{' '}
                      <span style={descriptionDetailsStyle}>
                        {membershipObject && membershipObject.Message}
                      </span>
                    </Descriptions.Item>
                  ) : null}
                </Descriptions>
              </Col>
            </Row>
            <Row gutter={[10, 10]}>
              <Col className="profile">
                <Descriptions
                  className="profile"
                  colon={false}
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label={I.t('FIRSTNAME')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.FirstName}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('SURNAME')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.SurName}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('TAXNUMBER')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.AFM}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('TAXOFFICE')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty &&
                        LookupsHelper.getDescription(
                          taxOffices,
                          userParty.TaxOfficeID
                        )}
                    </span>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
            <Row gutter={[10, 10]}>
              <Col className="profile">
                <Descriptions
                  className="profile"
                  colon={false}
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item
                    label={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{I.t('PHONE')}</span>
                        <span style={spanIconStyle}>
                          <PhoneOutlined style={iconStyle} />
                        </span>
                      </div>
                    }
                  >
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.Phone}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{I.t('FAX')}</span>
                        <span style={spanIconStyle}>
                          <PrinterOutlined style={iconStyle} />
                        </span>
                      </div>
                    }
                  >
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.Fax}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{I.t('MOBILE')}</span>
                        <span style={spanIconStyle}>
                          <MobileOutlined style={iconStyle} />
                        </span>
                      </div>
                    }
                  >
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.Mobile}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>{I.t('EMAIL')}</span>
                        <span style={spanIconStyle}>
                          <MailOutlined style={iconStyle} />
                        </span>
                      </div>
                    }
                  >
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.Email}
                    </span>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
            <Row gutter={[10, 10]}>
              <Col className="profile">
                <Descriptions
                  className="profile"
                  colon={false}
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label={I.t('CITY')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.City}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('STREET')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.Street}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('NUMBER')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.StreetNumber}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('POSTALCODE')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty && userParty.PostalCode}
                    </span>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
            <Row gutter={[10, 10]}>
              <Col className="profile">
                <Descriptions
                  className="profile"
                  colon={false}
                  column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  size="small"
                  bordered
                >
                  <Descriptions.Item label={I.t('REGION')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty &&
                        LookupsHelper.getDescription(
                          regions,
                          userParty.RegionID
                        )}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label={I.t('COUNTRY')}>
                    <span style={descriptionDetailsStyle}>
                      {userParty &&
                        LookupsHelper.getDescription(
                          countries,
                          userParty.CountryID
                        )}
                    </span>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            {LookupsHelper.getDescription(partyTypes, user.PartyType) ===
            'Merchant' ? (
              <List
                header={I.t('APPROVED_DOCS')}
                itemLayout="horizontal"
                dataSource={userParty && getCountryData()}
                renderItem={item => (
                  <List.Item
                    extra={
                      <Button
                        icon={
                          <FileDoneOutlined
                            style={{ fontSize: 20, color: '#468847' }}
                          />
                        }
                        onClick={() => showDocument(item.doc)}
                      />
                    }
                  >
                    <List.Item.Meta
                      avatar={<Avatar src={item.icon} />}
                      title={item.title}
                    />
                  </List.Item>
                )}
              />
            ) : null}
          </Col>
        </Row>
      </Portlet>

      {showModal ? (
        <Modal
          visible={showModal}
          title={I.t('APPROVED_DOCS')}
          width={800}
          onCancel={() => setShowModal(false)}
          footer={null}
        >
          {document === 'VDFM' ? (
            <VDFMDocument showApproveButton={false} />
          ) : document === 'HYDRA' ? (
            <HydraDocument showApproveButton={false} />
          ) : null}
        </Modal>
      ) : null}
    </div>
  );
};

export default Profile;
